import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TabComponent from '@/components/TabComponent.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientLayout',
  props: {
    patientId: {
        type: String || Number,
        required: true
    }
},
  setup(__props) {

const route = useRoute();

const isDependent = computed( ()=> route.query?.dependent == 'true');

const props = __props

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        count: 0,
        href: '/accounts/patients/show/' + props.patientId,
        allowed: true
    },
    {
        name: 'Dependents',
        count: 0,
        href: '/accounts/patients/show/' + props.patientId + '/dependents',
        allowed: !isDependent.value && window.$hasPermission('view-dependents')
    },
    {
        name: 'Bookings',
        count: 0,
        href: '/accounts/patients/bookings/' + props.patientId,
        allowed: window.$hasPermission('view-corporate-patients') || ( isDependent.value || window.$hasPermission('view-booking-of-dependents'))
    },
    {
        name: 'Medical Records',
        count: 0,
        href: '/accounts/patients/medical-record/show/' + props.patientId,
        allowed: 
            window.$hasPermission('view-corporate-patient-medical-records') ||
            window.$hasPermission('view-web-booking-medical-records') ||
            window.$hasPermission('view-contact-center-booking-medical-records') ||
            window.$hasPermission('view-patient-medical-records') ||
            window.$hasPermission('view-medical-records-in-offline')
    },
    // {
    //     name: 'Blocked Dates',
    //     count: 0,
    //     href: ''
    // }
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TabComponent, { tabs: tabs }),
    _renderSlot(_ctx.$slots, "contents")
  ]))
}
}

})